export default __webpack_public_path__ + "static/media/ic-safetypay.3d8181d2.png";